import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Translate } from 'react-localize-redux';
import styled, { css } from 'styled-components';

import { wipeInAfter } from './keyframes';
import Section from './section';

const ImportantText = styled.p`
  font-family: 'Noto Serif JP', serif;
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.75;
  margin: 0 0 0.75em;
  position: relative;
  text-align: center;
  color: ${props => props.theme.primary};

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: #ffffff;
  }

  ${props =>
    props.inView &&
    css`
      &::after {
        animation: ${wipeInAfter} 0.8s cubic-bezier(0.27, 0.94, 0.27, 0.94) 0.5s
          both;
      }
    `}
`;

const Text = styled.p`
  line-height: 2;
  margin: 0;
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: #ffffff;
  }

  ${props =>
    props.inView &&
    css`
      &::after {
        animation: ${wipeInAfter} 0.8s cubic-bezier(0.27, 0.94, 0.27, 0.94) 0.5s
          both;
      }
    `}
`;

/**
 * Story section
 */
const Story = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 1 });
  return (
    <Section
      background="#ffffff"
      heading="STORY"
      headingInvert={true}
      subHeading={<Translate id="psyLandingPage.story.subtitle" />}
    >
      <div ref={ref} />
      <ImportantText inView={inView}>
        <span style={{ display: 'inline-block' }}>
          <Translate id="psyLandingPage.story.intro.1" />
        </span>
        <span style={{ display: 'inline-block' }}>
          <Translate id="psyLandingPage.story.intro.2" />
        </span>
      </ImportantText>
      <Text inView={inView}>
        <Translate id="psyLandingPage.story.main.1" />
      </Text>
      <Text inView={inView}>
        <Translate id="psyLandingPage.story.main.2" />
      </Text>
      <Text inView={inView} style={{ marginTop: '1em' }}>
        <Translate id="psyLandingPage.story.main.3" />
      </Text>
    </Section>
  );
};

export default Story;
